export const createPaymentRedirect = () => {
  const successPage = '/payment-redirect';

  return new URL(successPage, window.location.origin).href;
};
